import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

export default function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50">
      <Card className="w-full max-w-md shadow-xl border-orange-200">
        <CardHeader className="text-center">
          <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-12 h-12 text-orange-600" />
          </div>
          <CardTitle className="text-3xl text-orange-700">Ödeme İptal Edildi</CardTitle>
        </CardHeader>
        
        <CardContent className="text-center space-y-4">
          <p className="text-slate-700 text-lg">
            Ödeme işleminiz iptal edildi.
          </p>
          
          <p className="text-slate-600 text-sm">
            Abonelik satın almak isterseniz, istediğiniz zaman fiyatlandırma sayfasından tekrar deneyebilirsiniz.
          </p>
          
          <div className="pt-4 space-y-3">
            <Button 
              onClick={() => navigate('/pricing')} 
              className="w-full bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700"
            >
              Fiyatlandırmaya Dön
            </Button>
            
            <Button 
              onClick={() => navigate('/')} 
              variant="outline"
              className="w-full"
            >
              Ana Sayfaya Git
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
